import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import PracticeAreaPage from "@/pages/PracticeAreaPage";
import ChiSono from "@/pages/ChiSono";
import Recensioni from "@/pages/Recensioni";
import Approfondimenti from "@/pages/Approfondimenti";
import ArticlePage from "@/pages/ArticlePage";
import Contatti from "@/pages/Contatti";
import Admin from "@/pages/Admin";
import RicorsoInvalidita from "@/pages/RicorsoInvalidita";
import CookieConsent from "@/components/CookieConsent";
import GtagEvents from "@/components/GtagEvents";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const NotFound = () => (
  <main className="container-site py-24 text-center" data-testid="not-found-page">
    <h1 className="font-serif text-4xl font-bold text-navy">Pagina non trovata</h1>
    <p className="mt-4 text-slate-600">La pagina che cerchi non esiste o è stata spostata.</p>
    <Link to="/" data-testid="not-found-home-link" className="btn-gold mt-8">
      Torna alla home
    </Link>
  </main>
);

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diritto-del-lavoro" element={<PracticeAreaPage slug="diritto-del-lavoro" />} />
            <Route path="/licenziamento" element={<PracticeAreaPage slug="licenziamento" />} />
            <Route path="/recupero-crediti-tfr" element={<PracticeAreaPage slug="recupero-crediti-tfr" />} />
            <Route path="/diritto-previdenziale" element={<PracticeAreaPage slug="diritto-previdenziale" />} />
            <Route path="/inps-ricorsi" element={<PracticeAreaPage slug="inps-ricorsi" />} />
            <Route path="/indebiti-inps-palermo" element={<PracticeAreaPage slug="indebiti-inps-palermo" />} />
            <Route path="/invalidita-civile" element={<PracticeAreaPage slug="invalidita-civile" />} />
            <Route path="/ricorso-inps-invalidita-accompagnamento-palermo" element={<RicorsoInvalidita />} />
            <Route path="/pensioni" element={<PracticeAreaPage slug="pensioni" />} />
            <Route path="/chi-sono" element={<ChiSono />} />
            <Route path="/recensioni" element={<Recensioni />} />
            <Route path="/approfondimenti" element={<Approfondimenti />} />
            <Route path="/approfondimenti/:slug" element={<ArticlePage />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <GtagEvents />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
